import { DepartmentRole } from '../../common/department-role';

export interface IRefreshTokenClaims {
    id: string;
    tokenId: string;
    domainId: string;
    role: DepartmentRole;
    tokenExpiration: number;
}


export class RefreshTokenClaims implements IRefreshTokenClaims {
    public id: string = '';
    public tokenId: string = '';
    public domainId: string = '';
    public role: DepartmentRole = DepartmentRole.Indeterminate;
    public tokenExpiration: number = 0;
}


